import { render, staticRenderFns } from "./subaru.vue?vue&type=template&id=62a8a3ea&"
import script from "./subaru.vue?vue&type=script&lang=js&"
export * from "./subaru.vue?vue&type=script&lang=js&"
import style0 from "./subaru.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports